const availableCities = {
  CO: ['Bogotá', 'Medellín', 'Cali', 'Chía'],
  MX: [
    'Gustavo A. Madero',
    'Azcapotzalco',
    'Miguel Hidalgo',
    'Cuauhtémoc',
    'Venustiano Carranza',
    'Cuajimalpa',
    'Álvaro Obregón',
    'Magdalena Contreras',
    'Tlalpan',
    'Xochimilco',
    'Coyoacán',
    'Benito Juáres',
    'Iztapalapa',
    'Iztacalco',
    'Tláhuac',
    'Villa Milpa',
    'Valle del Chalco',
    'La Paz (Los Reyez)',
    'Nezahulcóyotl',
    'Chimalhuacán',
    'Chicoloapan',
    'Texococo',
    'Ecatepec',
    'Coacalco',
    'Huixquilucan',
    'Naucalpan',
    'Tlalnepantla de Baz',
    'López Mateos',
    'Buena Vista',
    'Cuautitlán Izcalli',
    'Tultitlán',
    'Cuautitlán',
    'Tultepec',
    'Tecámac',
    'Santa Catarina',
    'San Pedro Garza García',
    'Cumbres',
    'Monterrey Centro',
    'Monterrey Sur',
    'Guadalupe',
    'Juárez',
    'Apodaca',
    'San Nicolás de los Garza',
    'General Escobedo',
    'Zapopan',
    'Guadalajara',
    'Tlaquepaque',
    'Tonala',
    'El Salto',
    'Tlajumulco de Zúñiga',
    'Santiago de Queretaro Sur',
    'Santiago de Queretaro Centro',
    'Corregidora',
    'Angeles de Queretaro',
    'Loma Dorada',
    'El Campanario',
    'Santiago de Queretaro Norte',
    'Juriquilla',
    'Mirador',
    'Satélite'
  ]
}

export default availableCities
